function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.6663 5.83329C11.6663 8.74588 8.43526 11.7792 7.35026 12.716C7.24918 12.792 7.12614 12.8331 6.99967 12.8331C6.87321 12.8331 6.75017 12.792 6.64909 12.716C5.56409 11.7792 2.33301 8.74588 2.33301 5.83329C2.33301 4.59562 2.82467 3.40863 3.69984 2.53346C4.57501 1.65829 5.762 1.16663 6.99967 1.16663C8.23735 1.16663 9.42434 1.65829 10.2995 2.53346C11.1747 3.40863 11.6663 4.59562 11.6663 5.83329Z",
  strokeWidth: 1.16667,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  stroke: "#006CA3"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.75 5.83337C8.75 6.79987 7.9665 7.58337 7 7.58337C6.0335 7.58337 5.25 6.79987 5.25 5.83337C5.25 4.86688 6.0335 4.08337 7 4.08337C7.9665 4.08337 8.75 4.86688 8.75 5.83337Z",
  strokeWidth: 1.16667,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  stroke: "#006CA3"
});

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.9bdf8b49.svg";
export { ForwardRef as ReactComponent };